module.exports = __webpack_public_path__ + "img/smile.12ba72f0.png";